<div class="settings-page-title">
  <h2>{{ 'Settings' | t }}</h2>
</div>

<div class="settings-menu">
  <a [routerLink]="['/documentInfo']">
    <image-loader-utils url="upload" extraClasses="upload-icon"></image-loader-utils>
    {{ 'Personal_Documents' | t }}
  </a>
  <a [routerLink]="['/accountdownload']">
    <image-loader-utils url="download" extraClasses="download-icon"></image-loader-utils>
    {{ 'Personal_Data' | t }}
  </a>

  <a [routerLink]="['/accountlock']">
    <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
    {{ 'Account_Lock' | t }}
  </a>

  <a [routerLink]="['/selflimits']">
    <image-loader-utils url="triangle" extraClasses="triangle-icon"></image-loader-utils>
    {{ 'Self_Limits' | t }}
  </a>
</div>
